<div *ngIf="starting" class="main-preloader" [@loadingAnimation]>
	<p>{{ statusLoader | lowercase }}</p>
	<img class="preloader" src="/assets/images/preloaders/progress.gif" />
</div>

<section
	class="login-page"
	[ngStyle]="{
		display: justSignedUp ? 'block' : 'flex',
		'flex-direction': justSignedUp ? undefined : 'column',
		'justify-content': justSignedUp ? undefined : 'center'
	}"
>
	<div *ngIf="justSignedUp" class="notification-container container">
		<h2
			class="h3 text-center"
			[innerHTML]="'PAGES.LOGIN.JUST_SIGNED_UP' | translate"
		></h2>
	</div>
	<div *ngIf="!starting" class="login container" [@enterAnimation]>
		<div class="row">
			<div class="signup">
				<!-- Logo. -->
				<a href="/" title="Zenklub"
					><img
						width="188px"
						class="logo"
						src="/assets/images/zenklub_blue.png"
						alt="Zenklub"
				/></a>
				<!-- E-mail. -->
				<div class="form-group text-left">
					<div class="inner-addon right-addon">
						<fa-icon icon="envelope" aria-hidden="true"></fa-icon>
						<input
							#inputEmail
							class="form-control"
							[(ngModel)]="email"
							id="Email"
							name="Email"
							placeholder="{{ 'PAGES.LOGIN.EMAIL' | translate }}"
							type="email"
							(keyup.enter)="login()"
						/>
					</div>
					<span
						class="field-validation-valid text-danger"
						data-valmsg-for="Email"
						data-valmsg-replace="true"
					></span>
				</div>

				<!-- Password. -->
				<div class="form-group text-left">
					<div class="inner-addon right-addon">
						<fa-icon icon="lock" aria-hidden="true"></fa-icon>
						<input
							#inputPassword
							class="form-control"
							[(ngModel)]="password"
							id="Password"
							name="Password"
							placeholder="{{ 'PAGES.LOGIN.PASSWORD' | translate }}"
							type="password"
							(keyup.enter)="login()"
							onfocus="this.select()"
						/>
					</div>
					<span
						class="field-validation-valid text-danger"
						data-valmsg-for="Password"
						data-valmsg-replace="true"
					></span>
				</div>

				<!-- User Id. -->
				<div class="form-group text-left">
					<div class="inner-addon right-addon">
						<fa-icon icon="envelope" aria-hidden="true"></fa-icon>
						<input
							#inputProfessionalId
							class="form-control"
							[(ngModel)]="professionalId"
							id="ProfessionalId"
							name="ProfessionalId"
							placeholder="ProfessionalId"
							(keyup.enter)="login()"
						/>
					</div>
					<span
						class="field-validation-valid text-danger"
						data-valmsg-for="ProfessionalId"
						data-valmsg-replace="true"
					></span>
				</div>

				<!-- Preloader. -->
				<div class="preloader" *ngIf="loading">
					<img src="/assets/images/preloaders/progress.gif" />
					<p class="loaderStatus">{{ currentOp }}</p>
				</div>

				<!-- Error (if any). -->
				<div class="alert alert-error" *ngIf="error && !loading">
					<fa-icon icon="exclamation-triangle"></fa-icon> {{ error }}
				</div>
				<!-- Login button. -->
				<div *ngIf="!loading" class="form-group">
					<input
						[disabled]="loading"
						(click)="login()"
						type="submit"
						value="{{ 'PAGES.LOGIN.LOGIN' | translate }}"
						class="btn btn-primary btn-block"
					/>
				</div>
			</div>
		</div>
	</div>
</section>
